// extracted by mini-css-extract-plugin
export default {"link":"link__AG1Nl","tooltip":"tooltip__wo3x+"};